'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * See ticket REV-2572 for details about this script and StackAdapt.
 */
var stackAdaptController = {
  init: function init() {
    try {
      /*eslint-disable */
      !function (s, a, e, v, n, t, z) {
        if (s.saq) {
          return;
        }
        n = s.saq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!s._saq) {
          s._saq = n;
        }
        n.push = n;
        n.loaded = !0;
        n.version = '1.0';
        n.queue = [];
        t = a.createElement(e);
        t.async = !0;
        t.src = v;
        z = a.getElementsByTagName(e)[0];
        z.parentNode.insertBefore(t, z);
      }(global.window, global.document, 'script', 'https://tags.srv.stackadapt.com/events.js');

      if (global.saq) {
        global.saq('ts', 'DQ-Smsn3_5A5W6EhD-VC6w');
      }
    } catch (ex) {
      // noop
    }
  }
};

exports.default = stackAdaptController;